import {
  CartQuoteServices,
  CartUpdateServices,
  FlightServices,
  getObjectKeysAsObject,
  FlightPassengerServices,
  AirPFExerciseServices,
  SeatServices,
  ContactInformationServices,
  PassportServices,
} from "@hopper-b2b/checkout";
import { CartFulfillServices } from "../states/CartFulfill";
import { checkoutServices } from "./common";

export const Services = {
  ...CartFulfillServices,
  ...CartQuoteServices,
  ...CartUpdateServices,
  ...checkoutServices,
  ...FlightServices,
  ...ContactInformationServices,
  ...FlightPassengerServices,
  ...PassportServices,
  ...AirPFExerciseServices,
  ...SeatServices,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
